'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '../lib/utils';

const TABS = [
  { name: 'Курс валют ЦБ РФ', href: '/finance', segment: 'cb-rates' },
  { name: 'График валют', href: '/finance/currency-chart', segment: 'currency-chart' },
  { name: 'Конвертер', href: '/finance/converter', segment: 'converter' },
  { name: 'Курс криптовалют', href: '/finance/crypto', segment: 'crypto' },
  { name: 'Новости', href: '/finance/news', segment: 'news' },
] as const;

function getActiveSegment(pathname: string) {
 // pathname: /finance or /finance/crypto/...
  const parts = pathname.split('/').filter(Boolean);

  // parts[0] === 'finance'
  const seg = parts[1]; // второй сегмент после /finance
  return seg ?? 'cb-rates'; // дефолтный таб для /finance
}

export function FinanceTabs() {
  const pathname = usePathname();
  const activeSegment = getActiveSegment(pathname);

  return (
    <div className="border-b border-gray-700">
      {/* горизонтальный скролл вместо wrap — меньше “прыжков” */}
      <nav
        className="flex gap-6 overflow-x-auto whitespace-nowrap -mb-px scrollbar-none"
        aria-label="Финансовые разделы"
      >
        {TABS.map((tab) => {
          const isActive = activeSegment === tab.segment;

          return (
            <Link
              key={tab.segment}
              href={tab.href}
              prefetch={false} // ✅ ключевая оптимизация: не префетчим все табы
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'py-4 px-1 border-b-2 font-medium transition-colors duration-200',
                isActive
                  ? 'border-main text-slate-100'
                  : 'border-transparent text-gray-300 hover:text-gray-200 hover:border-gray-500',
              )}
            >
              {tab.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
